var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":function($event){return _vm.onClick()}}},[_c('div',{staticClass:"burger-icon",class:{ open: _vm.open }},[_c('span'),_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }